// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { DynamicPropertyCardLuxuryProps } from './DynamicPropertyCardLuxury.types';
import { StyledDynamicPropertyCardLuxury } from './DynamicPropertyCardLuxury.styles';
/* eslint-disable @nx/enforce-module-boundaries */
import { DynamicPropertyCards } from '@marriott/mi-leisure-components';

// Use named rather than default exports.
export const DynamicPropertyCardLuxury: FC<DynamicPropertyCardLuxuryProps> = props => {
  // const textVal = text ?? 'DynamicPropertyCardLuxury prop fallback';
  return (
    <StyledDynamicPropertyCardLuxury
      data-testid="luxury-DynamicPropertyCardLuxury"
      data-component-name="m-luxury-DynamicPropertyCardLuxury"
    >
      <DynamicPropertyCards {...props} />
    </StyledDynamicPropertyCardLuxury>
  );
};
